import {
  POPULAR_PURCHASED_CATEGORY_AND_PRODUCT,
  CUSTOMER_METRICS,
  PI_METRIC,
} from 'Pages/Analytics/constants'
import React from 'react'
import { CustomerPivotTypes } from 'Services/Analytics/Pivot.service'
import PivotTableTemplate from '../../Components/PivotTable.Template'

const PivotRow1 = () => {
  return (
    <>
      <div className="mb-4 font-semibold">Product Insight</div>
      <div className="py-4 col-span-1">
        <div className="mb-4 font-semibold">Popular Purchased Category and Product by LTV</div>
        <PivotTableTemplate
          type={CustomerPivotTypes.ProductInsight}
          isCustomer
          defaultDimensions={[{ code: 'ltv' }, ...POPULAR_PURCHASED_CATEGORY_AND_PRODUCT]}
          defaultMetrics={CUSTOMER_METRICS}
        />
      </div>
      <div className="py-4 col-span-1">
        <div className="mb-4 font-semibold">Popular Purchased Category and Product by CLC</div>
        <PivotTableTemplate
          isCustomer
          type={CustomerPivotTypes.ProductInsight}
          defaultDimensions={[{ code: 'life_cycle' }, ...POPULAR_PURCHASED_CATEGORY_AND_PRODUCT]}
          defaultMetrics={CUSTOMER_METRICS}
        />
      </div>
    </>
  )
}

export default PivotRow1
